<template>
    <div class="rv">
        <h4>Este servicio no se encuentra disponible por ahora, gracias por su atención.</h4>


    </div>
</template>
<script>
import data from "@/data/common";
export default {
    data:() => ({
        detalle: data.raices,
        slider1:[
            'mimosa.jpg', 'mollecostenio.jpg', 'ponciana.jpg'
        ]
    }),
    methods:{
        register(){
            this.$router.push({
                path: `/raices-de-vida/register`
            })
        }
    }
}
</script>
<style>
 /* Extra small devices (phones, 600px and down) */
@media screen and (max-width: 1920px) {

}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media screen and (max-width: 1280px) {

}

/* Medium devices (landscape tablets, 768px and up) */
@media screen and (max-width: 768px) {

}

/* Large devices (laptops/desktops, 992px and up) */
@media screen and (max-width: 480px) {
    .rv h3{
        font-size: 1.2rem;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/raices/index.vue